import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import {
  getAllContentEntityAudios,
  // addAudio,
  // updateAudio,
  // setDefaultAudio,
  // removeAudio,
  downloadAudio,
} from './thunks';
import { ContentEntityaudiosState } from './types';

export const name = 'ContentEntityAudios';

const initialState: ContentEntityaudiosState = {
  data: [],
  updatingStatus: 'idle',
  status: 'idle',
  downloadStatus: 'idle',
};
getAllContentEntityAudios;
export const getAllContentEntityAudiosAsync = createAsyncThunk(
  name + '/getAllContentEntityAudios',
  getAllContentEntityAudios
);

// export const addAudioAsync = createAsyncThunk(name + '/addAudio', addAudio);

// export const updateAudioAsync = createAsyncThunk(
//   name + '/updateAudio',
//   updateAudio
// );

// export const setDefaultAudioAsync = createAsyncThunk(
//   name + '/setDefaultAudio',
//   setDefaultAudio
// );

// export const removeAudioAsync = createAsyncThunk(
//   name + '/removeAudio',
//   removeAudio
// );

export const downloadAudioAsync = createAsyncThunk(
  name + '/downloadAudio',
  downloadAudio
);

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    clear: (_) => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllContentEntityAudiosAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(getAllContentEntityAudiosAsync.fulfilled, (state, action) => {
        state.status = 'idle';
        state.data = action.payload;
      })
      .addCase(getAllContentEntityAudiosAsync.rejected, (state, action) => {
        state.status = 'failed';
      })
      // .addCase(addAudioAsync.pending, (state) => {
      //   state.updatingStatus = 'loading';
      // })
      // .addCase(addAudioAsync.fulfilled, (state, action) => {
      //   state.updatingStatus = 'idle';
      // })
      // .addCase(addAudioAsync.rejected, (state, action) => {
      //   state.updatingStatus = 'failed';
      // })
      // .addCase(updateAudioAsync.pending, (state) => {
      //   state.updatingStatus = 'loading';
      // })
      // .addCase(updateAudioAsync.fulfilled, (state, action) => {
      //   state.updatingStatus = 'idle';
      // })

      // .addCase(updateAudioAsync.rejected, (state, action) => {
      //   state.updatingStatus = 'failed';
      // })
      // .addCase(setDefaultAudioAsync.pending, (state) => {
      //   state.updatingStatus = 'loading';
      // })
      // .addCase(setDefaultAudioAsync.fulfilled, (state, action) => {
      //   state.updatingStatus = 'idle';
      // })
      // .addCase(setDefaultAudioAsync.rejected, (state, action) => {
      //   state.updatingStatus = 'failed';
      // })
      // .addCase(removeAudioAsync.pending, (state) => {
      //   state.updatingStatus = 'loading';
      // })
      // .addCase(removeAudioAsync.fulfilled, (state, action) => {
      //   state.updatingStatus = 'idle';
      // })
      // .addCase(removeAudioAsync.rejected, (state, action) => {
      //   state.updatingStatus = 'failed';
      // })
      .addCase(downloadAudioAsync.pending, (state) => {
        state.downloadStatus = 'loading';
      })
      .addCase(downloadAudioAsync.fulfilled, (state, action) => {
        state.downloadStatus = 'idle';
      })
      .addCase(downloadAudioAsync.rejected, (state, action) => {
        state.downloadStatus = 'failed';
      });
  },
});

export const actions = slice.actions;

export default slice.reducer;
